var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneOneIconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99166 5.72222C7.22663 5.72222 8.22777 4.72108 8.22777 3.48611C8.22777 2.25114 7.22663 1.25 5.99166 1.25C4.75669 1.25 3.75555 2.25114 3.75555 3.48611C3.75555 4.72108 4.75669 5.72222 5.99166 5.72222Z",
    stroke: "#26A74A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3386 1.56946C10.988 1.96075 11.4223 2.67272 11.4223 3.48612C11.4223 4.29952 10.988 5.0115 10.3386 5.40279",
    stroke: "#26A74A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20001 12.3666V12.75H10.7833V12.3666C10.7833 10.9354 10.7833 10.2198 10.5048 9.6731C10.2598 9.19225 9.86883 8.80128 9.38797 8.55626C8.84131 8.27774 8.12569 8.27774 6.69445 8.27774H5.2889C3.85766 8.27774 3.14204 8.27774 2.59537 8.55626C2.11451 8.80128 1.72356 9.19225 1.47855 9.6731C1.20001 10.2198 1.20001 10.9354 1.20001 12.3666Z",
    stroke: "#26A74A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9778 12.75V12.3667C13.9778 10.9354 13.9778 10.2198 13.6993 9.67315C13.4543 9.19229 13.0633 8.80132 12.5824 8.5563",
    stroke: "#26A74A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneOneIconBlack);
export default __webpack_public_path__ + "static/media/one-one-icon-black.447d9fec6a1c48aaecb5391429b5d9dd.svg";
export { ForwardRef as ReactComponent };